import React from 'react';

const BORTLE_COLORS: Record<number, string> = {
  1: '#000000',
  2: '#333333',
  3: '#0000CC',
  4: '#007099',
  5: '#00CC00',
  6: '#99CC00',
  7: '#FFFF00',
  8: '#FF8800',
  9: '#FF0000',
};

const BORTLE_LABELS: Record<number, string> = {
  1: 'Excellent dark sky',
  2: 'Truly dark site',
  3: 'Rural sky',
  4: 'Rural/suburban',
  5: 'Suburban sky',
  6: 'Bright suburban',
  7: 'Suburban/urban',
  8: 'City sky',
  9: 'Inner-city sky',
};

interface Props {
  bortle: number;
  showLabel?: boolean;
  size?: 'sm' | 'md';
}

export const BortleBadge: React.FC<Props> = ({ bortle, showLabel = false, size = 'sm' }) => {
  const color = BORTLE_COLORS[bortle] || '#666';
  const label = BORTLE_LABELS[bortle] || '';
  const needsLightText = bortle <= 4;

  return (
    <span
      className={`inline-flex items-center gap-1.5 font-medium rounded-full ${
        size === 'sm' ? 'px-2.5 py-0.5 text-xs' : 'px-3 py-1 text-sm'
      }`}
      style={{
        backgroundColor: color,
        color: needsLightText ? '#fff' : '#000',
      }}
    >
      Bortle {bortle}
      {showLabel && <span className="font-normal">{label}</span>}
    </span>
  );
};

export { BORTLE_COLORS, BORTLE_LABELS };
